import { FeatureTeaser } from '../FeatureTeaser';
import driverAppImage from '../../../assets/images/landingPage/driver-app.webp';
import { CustomFormattedMessage } from '../../../i18n/i18n';
import { useLocale } from '../../../i18n/locale';

const LOCALE_GERMAN = 'de-DE';

interface DriverAppTeaserProps {
  key?: string;
}

export const DriverAppTeaser = ({ key }: DriverAppTeaserProps) => {
  const { locale } = useLocale();

  return (
    <FeatureTeaser
      image={driverAppImage}
      headline={
        <CustomFormattedMessage
          id={'landing.partnerTeaser.driverApp.headline'}
        />
      }
      content={
        <CustomFormattedMessage id={'landing.partnerTeaser.driverApp.body'} />
      }
      onClick={() => {
        const link =
          locale === LOCALE_GERMAN
            ? 'https://www.man.eu/de/de/service/man-driver-app.html'
            : 'https://www.man.eu/uk/en/service/man-driver-app.html';

        window.open(link, '_blank', 'noopener');
      }}
    />
  );
};
